import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { NAV_ITEMS } from "@/components/layout/AppShell";
import { Card, Page } from "@/components/ui";

const DESCRIPTIONS: Record<string, string> = {
  "/chat": "Stel vragen over de data in gewone taal en krijg antwoord met de gebruikte SQL.",
  "/evaluaties": "Start een evaluatie van een agent op een vragenlijst en volg de voortgang live.",
  "/runs": "Bekijk eerdere evaluaties, scores, traces en gegenereerde SQL.",
  "/vragenlijsten": "Beheer de vragenlijsten (datasets) met referentie-SQL voor evaluaties.",
  "/context": "Bekijk en verbeter de kennis over tabellen en begrippen die de agents gebruiken.",
};

export default function HomePage() {
  return (
    <Page>
      <div className="mb-8 max-w-2xl">
        <p className="mb-2 text-sm font-semibold uppercase tracking-wider text-sl-yellow-dark">Simon Loos · BI Agents</p>
        <h1 className="text-3xl font-semibold tracking-tight">Vraag het de data</h1>
        <p className="mt-2 text-muted-foreground">
          Het interne analyseplatform voor natuurlijke-taalvragen op het datawarehouse van Simon Loos, met evaluaties en beheer van de databasecontext.
        </p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {NAV_ITEMS.map(({ to, label, icon: Icon }) => (
          <Link key={to} to={to} className="group">
            <Card className="h-full p-5 transition-all group-hover:-translate-y-0.5 group-hover:border-sl-yellow group-hover:shadow-pop">
              <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-md bg-sl-yellow text-sl-charcoal">
                <Icon className="h-5 w-5" />
              </div>
              <h2 className="flex items-center gap-2 text-lg font-semibold">
                {label}
                <ArrowRight className="h-4 w-4 opacity-0 transition-opacity group-hover:opacity-100" />
              </h2>
              <p className="mt-1 text-sm text-muted-foreground">{DESCRIPTIONS[to]}</p>
            </Card>
          </Link>
        ))}
      </div>
    </Page>
  );
}
